import * as React from 'react';
import { LoadingSpinner, LoadingSpinnerColor, CaptionTypography } from '../../../atoms';
import type { ComplexTreeLoadingStateProps } from '../types';

export const ComplexTreeLoadingState: React.FC<ComplexTreeLoadingStateProps> = ({ icon, message, ariaLabel }) => (
	<div
		className="flex h-full flex-col items-center justify-center px-[0.5rem] py-[1rem] text-center"
		data-testid="complex-tree-loading-state"
		role="status"
		aria-label={ariaLabel}
		aria-live="polite"
	>
		<div className="mb-[0.6rem]" aria-hidden="true">{icon ?? <LoadingSpinner color={LoadingSpinnerColor.SECONDARY} />}</div>
		<CaptionTypography className="text-secondary">{message ?? ''}</CaptionTypography>
	</div>
);
